import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { STORAGE_KEY } from 'utils/constants';
import { createStore, applyMiddleware, compose } from 'redux';
import { initStateWithPrevTab, createStateSyncMiddleware, withReduxStateSync } from 'redux-state-sync'
import { persistStore, persistCombineReducers } from 'redux-persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import storage from 'redux-persist/lib/storage';

import * as Sentry from "@sentry/react";

const config = {
  whitelist: ['HITRACT__AUTHENTICATION_CREATE_SUCCESS', 'HITRACT__AUTHENTICATION_RESET_REQUEST'],
  // predicate: (action) => {
  //   const blacklist = ['persist/PERSIST', 'persist/PURGE', 'persist/REHYDRATE'];
  //   if (typeof action !== "function") {
  //     if (Array.isArray(blacklist)) {
  //       return blacklist.indexOf(action.type) < 0;
  //     }
  //   }
  //   return false;
  // }
}

import sagas from 'sagas';
import reducers from 'reducers';

const storeApp = (LOGGER = true) => {
  const persistConfig = {
    key: STORAGE_KEY,
    storage: storage,
    whitelist: ['authentication', 'currentUser', 'metadata', 'hitSearch', 'appSettings', 'chat'],
    blacklist: [''],
  };

  const sagaMiddleware = createSagaMiddleware();
  const persistedReducer = persistCombineReducers(persistConfig, reducers);

  const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    stateTransformer: state => {
      if (state.authentication.authToken) {
        return null;
      }

      // Transform the state to remove sensitive information
      const transformedState = {
        ...state,
        authentication: {
          authToken: null
        },
        metadata: null,
      };
  
      return transformedState;
    },
  });

  const rootReducer = (state, action) => {
    if (action.type === 'HITRACT__AUTHENTICATION_RESET_REQUEST') {
      storage.removeItem(`persist:${STORAGE_KEY}`)
      state = undefined
    }
  
    return persistedReducer(state, action)
  }

  // eslint-disable-next-line
  const store = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' && LOGGER ? createStore(
    withReduxStateSync(rootReducer), /* preloadedState, */
    {},
    composeWithDevTools(
      applyMiddleware(logger),
      applyMiddleware(sagaMiddleware),
      applyMiddleware(createStateSyncMiddleware(config)),
      sentryReduxEnhancer
    ),
  ) : createStore(
    withReduxStateSync(rootReducer),
    {},
    compose(
      applyMiddleware(sagaMiddleware),
      applyMiddleware(createStateSyncMiddleware(config)),
      sentryReduxEnhancer
    ),
  );

  // initStateWithPrevTab(store)

  store.runSaga = sagaMiddleware.run;
  store.runSaga(sagas);

  return store;
};

export const store = storeApp();

export const persistor = persistStore(store);
